import React from "react";
import { cardStyle as styles } from "./sport.tailwind";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../lib/constants/routeConstant";

//FOR DEMO CHANGED SPORT NAME TO SEASON NAME
// Areana List Card
const SportCard = ({ sport, backgroundImage, commingSoon=false }) => {
  const navigate = useNavigate();

  // handle onClick
  const handleSportClick = () => {
    navigate(`${routeConstant.SPORT_PAGE}/${sport?._id}`)
  }
  
  return (
    <div
      className={styles.card}
      style={{ borderColor: 'rgba(209, 209, 209, 0.80)' }}
      onClick={handleSportClick}
    >
      {/* overlay */}
      <div className={styles.bottom_overlay} style={{ backgroundImage: `url(${backgroundImage})` }} />

      {/* main-text-content */}
      {/* <h2 className={styles.heading}>{sport?.sportName}</h2> */}
      <h2 className={styles.heading}>{sport?.seasonName}</h2>
      {commingSoon && <p className={styles.subHeading}>Comming Soon</p>}
    </div>
  );
};

export default SportCard;
